import { RefCallBack } from "react-hook-form";

/**
 * Wraps a react-hook-form field `ref` so that when the form focuses the field
 * — e.g. via `shouldFocusError` after a failed validation, or `setFocus` — the
 * element is smooth-scrolled into view. Native focus (text inputs, editors,
 * etc.) is preserved when the underlying element exposes a `focus` method.
 *
 * Use it on the element a Controller renders:
 *
 *   <Input ref={focusScrollRef(field.ref)} />
 */
export const focusScrollRef =
  (ref: RefCallBack) =>
  (node: unknown): void => {
    if (!node) {
      ref(node);
      return;
    }
    const element = node as HTMLElement;
    const nativeFocus =
      typeof element.focus === "function"
        ? element.focus.bind(element)
        : undefined;
    ref({
      ...element,
      focus: () => {
        nativeFocus?.({ preventScroll: true });
        element.scrollIntoView?.({ behavior: "smooth" });
      },
    });
  };
